// client/src/components/pages/ContactPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ContactPage.css';

const ContactPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formFeedback, setFormFeedback] = useState({ message: '', type: '' });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    setIsSubmitting(true);
    setFormFeedback({ message: 'Sending your message...', type: 'info' });

    const formData = new FormData(form);
    const messageData = {
      name: formData.get('name'),
      email: formData.get('email'),
      subject: formData.get('subject'),
      message: formData.get('message'),
    };

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/messages`, messageData);
      setFormFeedback({
        message: 'Message Sent! Thank you for contacting Makah Medics. We will get back to you shortly.',
        type: 'success',
      });
      form.reset();
    } catch (error) {
      setFormFeedback({
        message: 'Submission failed. Please check your connection or message us directly on WhatsApp.',
        type: 'error',
      });
      console.error('Contact form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page-wrapper">
      <div className={`contact-page ${isVisible ? 'is-visible' : ''}`}>
        <section className="contact-header-section animate-section">
          <h1>Let's Connect</h1>
          <p>We're here to answer your questions and help you find the right solutions for your facility.</p>
        </section>

        <section className="contact-main-section animate-section">
          <div className="contact-details">
            <h2>Direct Contact Information</h2>
            <p>For immediate assistance or to speak with a specialist directly, please use the information below.</p>
            <div className="contact-info-item">
              <i className="fas fa-phone-alt"></i>
              <div>
                <strong>Phone Lines</strong>
                <a href="tel:+255778900681">0778 900 681</a>
                <a href="tel:+255779900682">0779 900 682</a>
              </div>
            </div>
            <div className="contact-info-item">
              <i className="fab fa-whatsapp"></i>
              <div>
                <strong>WhatsApp</strong>
                <a href="https://wa.me/255769880769" target="_blank" rel="noopener noreferrer">+255 769 880 769</a>
              </div>
            </div>
            <div className="contact-info-item">
              <i className="fas fa-envelope"></i>
              <div>
                <strong>Email Address</strong>
                <a href="mailto:makahmedics@gmail.com">makahmedics@gmail.com</a>
              </div>
            </div>
            <div className="contact-info-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <strong>Our Office</strong>
                <span>Mbuyuni, Salasala Road, Kinondoni, Dar es Salaam</span>
              </div>
            </div>
            <div className="contact-info-item">
              <i className="fas fa-box"></i>
              <div>
                <strong>Postal Address</strong>
                <span>S.L.P 999, Dar es Salaam</span>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <h2>Send Us a Message</h2>
            <form onSubmit={handleFormSubmit}>
              <div className="form-group floating-label">
                <input type="text" id="name" name="name" required placeholder=" " />
                <label htmlFor="name">Full Name</label>
              </div>
              <div className="form-group floating-label">
                <input type="email" id="email" name="email" required placeholder=" " />
                <label htmlFor="email">Email Address</label>
              </div>
              <div className="form-group floating-label">
                <input type="text" id="subject" name="subject" required placeholder=" " />
                <label htmlFor="subject">Subject</label>
              </div>
              <div className="form-group floating-label">
                <textarea id="message" name="message" rows="5" required placeholder=" "></textarea>
                <label htmlFor="message">Your Message</label>
              </div>
              <button type="submit" className="btn-submit" disabled={isSubmitting}>
                <span>{isSubmitting ? 'Sending...' : 'Send Message'}</span>
                <i className={`fas ${isSubmitting ? 'fa-circle-notch fa-spin' : 'fa-paper-plane'}`}></i>
              </button>

              {formFeedback.message && (
                <div className={`contact-status-banner ${formFeedback.type}`} role="alert">
                  <i
                    className={`fas ${
                      formFeedback.type === 'success'
                        ? 'fa-check-circle'
                        : formFeedback.type === 'error'
                        ? 'fa-exclamation-circle'
                        : 'fa-info-circle'
                    }`}
                  ></i>
                  <span>{formFeedback.message}</span>
                </div>
              )}
            </form>
          </div>
        </section>

        <section className="map-section animate-section">
          <h2>Visit Us</h2>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d990.5898864700877!2d39.2014796284083!3d-6.688846399653199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x185c453805981477%3A0xe54d6e9f0e139151!2sMakah%20Medics!5e0!3m2!1sen!2stz!4v1721865600000!5m2!1sen!2stz"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Makah Medics Office Location"
            ></iframe>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContactPage;
